import React, { Component } from 'react';
import { Portal, Typography } from '@mui/material';
import PortalLink from '../../common/PortalLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCat } from '@fortawesome/pro-light-svg-icons';

class PortalLinkTests extends Component {
  render() {
    return (
      <>
        <Typography component="h3">SX</Typography>
        <PortalLink
          sx={{ border: '1px solid hotpink' }}
          href="Google.com"
          title="new target"
          underline="hover"
        >
          Orange Link
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          External Links/Target
        </Typography>
        <PortalLink sx={{ display: 'block' }} href="Google.com" target="_blank">
          _blank
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" target="_new">
          _new
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" target="">
          empty target (should not display as external)
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" target="fubar">
          fubar target (should not display as external)
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          no target attribute (should not display as external)
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          Classes
        </Typography>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          className="myOdu__customClass"
          underline="hover"
        >
          Custom class
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" underline="hover">
          No Custom class, not externalLink
        </PortalLink>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          target="_blank"
          className=""
          underline="hover"
        >
          External Link with empty custom class
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          Underline
        </Typography>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          title="Underline Always"
          underline="always"
        >
          Underline Always
        </PortalLink>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          title="Underline Hover"
          underline="hover"
        >
          Underline Hover
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" title="Underline null" underline="">
          Underline null
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" title="Underline not specified">
          Underline not specified (should default to none)
        </PortalLink>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          title="Underline none"
          underline="none"
        >
          Underline none
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          Children{' '}
        </Typography>
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          <Typography component="h4">This link has a plain typography child</Typography>
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          This link a string child
        </PortalLink>
        <br />
        link with no children &rarr;
        <PortalLink sx={{ display: 'block' }} href="Google.com"></PortalLink>&larr;
        <br />
        link with empty string children &rarr;
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          {''}
        </PortalLink>
        &larr;
        <br />
        link with null children&rarr;
        <PortalLink href="Google.com">{null}</PortalLink>&larr;
        <br />
        link with img child
        <div style={{ height: '50px', width: '50px' }}>
          <PortalLink href="Google.com">
            <img src="img/oduCrown_blue.svg" alt="duo" />
          </PortalLink>
        </div>
        <br />
        link with font awesome child
        <PortalLink href="Google.com">
          <FontAwesomeIcon icon={faCat} />
        </PortalLink>
        <br />
        <PortalLink href="Google.com">
          <ul>
            <li>This link has a complex child</li>
            <li>Child 2</li>
            <li>Child 3</li>
          </ul>
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          ID{' '}
        </Typography>
        <PortalLink sx={{ display: 'block' }} href="Google.com" id="customId">
          This link has a custom ID
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" id="">
          This link has an empty ID (should generate ID based on title)
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" aria-label="some label here">
          This link has no ID prop, but has a label (should generate ID based on label)
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" title="some title here">
          This link has no ID prop, but has a title (should generate ID based on title)
        </PortalLink>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          aria-label="some label here"
          title="some title here"
        >
          This link has no ID prop, but has title and label (should generate ID based on label)
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          Label/Title Heirarchy
        </Typography>
        <PortalLink sx={{ display: 'block' }} href="Google.com" ariaLabel="ariaLabel">
          AriaLabel should output an aria-label with the label ariaLabel
        </PortalLink>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          ariaLabel="ariaLabel"
          aria-label="aria-label"
        >
          AriaLabel and aria-label (aria-label should win)
        </PortalLink>
        <PortalLink
          sx={{ display: 'block' }}
          href="Google.com"
          title="title"
          ariaLabel="ariaLabel"
          aria-label="aria-label"
        >
          Aria-label, ariaLabel prop and title prop, it should have aria-label and title
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" title="title">
          Just title
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          No props, should generate from text
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" aria-label="">
          Aria-label empty, should generate from text
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" aria-label={null}>
          Aria-label null, should generate from text
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com" aria-label="" title="some title">
          Aria-label empty but has title, should generate from title
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          No aria-label or title, should generate from text
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          <Typography component="h4">
            {' '}
            No aria-label or title, should generate from child{' '}
          </Typography>
        </PortalLink>
        <br />
        <PortalLink sx={{ display: 'block' }} href="Google.com">
          <ul>
            <li>No aria-label or title, should generate from complex child</li>
            <li>Child 2</li>
            <li>Child 3</li>
          </ul>
        </PortalLink>
        <br />
        link with null children&rarr;
        <PortalLink href="Google.com">{null}</PortalLink>&larr;
        <br />
        link with img child
        <div style={{ height: '50px', width: '50px' }}>
          <PortalLink href="Google.com">
            <img src="img/oduCrown_blue.svg" alt="duo" />
          </PortalLink>
        </div>
        <br />
        link with font awesome child
        <PortalLink href="Google.com">
          <FontAwesomeIcon icon={faCat} />
        </PortalLink>
        <Typography component="h3" sx={{ mt: 4 }}>
          Special Classes
        </Typography>
        <PortalLink sx={{ display: 'block' }} className="phone" href="">
          Phone 555-555-5555
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} className="email" href="">
          Email example@example.com
        </PortalLink>
        <PortalLink sx={{ display: 'block' }} className="newTab" href="">
          New Tab Link
        </PortalLink>
      </>
    );
  }
}

export default PortalLinkTests;
